import styled from '@emotion/styled';

export const Loader = styled.div<{ size: number; color: string }>`
  display: inline-block;
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  border-width: ${({ size }) => `${size / 9.5}px`};
  border-radius: 50%;
  border-style: solid;
  border-color: ${({ color }) => color};
  border-bottom-color: transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
`;
